import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useUser } from '@clerk/clerk-react';
import { CustomClerkSignUpForm } from '../components/auth/CustomClerkSignUpForm';
import { normalizeAppRole, portalHomePathForRole } from '../lib/portalRouting';

export const Route = createFileRoute('/signup')({
  component: SignUpRouteComponent,
});

function SignUpRouteComponent() {
  const { user } = useUser();
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 p-4">
      <CustomClerkSignUpForm
        signInHref="/login"
        afterSignUpRedirect="/client/orders"
        onAfterSignUpComplete={() =>
          portalHomePathForRole(normalizeAppRole(user?.publicMetadata?.role))
        }
      />
      <Outlet />
    </div>
  );
}
